import { render } from "./OrderInfoCard.vue?vue&type=template&id=83dc2aba&scoped=true"
import script from "./OrderInfoCard.vue?vue&type=script&lang=js"
export * from "./OrderInfoCard.vue?vue&type=script&lang=js"

import "./OrderInfoCard.vue?vue&type=style&index=0&id=83dc2aba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83dc2aba"]])

export default __exports__